<template>
		<div class="car-quote">
			<b-navbar class="row bg-dark-grey top px-0 navbar-auction" :sticky="true">
				<b-col md="8" offset-md="2" v-if="false">
				<b-form-group :invalid-feedback="car.plateInvalidFeedback" :state="car.plateState" description="Vehículos sin pérdida total y desde el 2013">
						<b-input-group class="mt-3">
							<b-form-input size="lg" v-model.trim="car.plate" :state="car.plateState" @keyup="uppercase" trim></b-form-input>
								<b-input-group-append>
									<b-button variant="info" @click="searchByPlate"><font-awesome-icon :icon="['fal', 'search']" size="lg" /></b-button>
								</b-input-group-append>
						</b-input-group>
					</b-form-group>
				</b-col>
				<b-col lg="4" offset-lg="4" class="text-center mt-2">
					<b-form-group description="Vehículos sin pérdida total y desde el 2013">
						<b-input-group class="mt-3">
							<b-form-input placeholder="Ingresa tu patente" size="lg" v-model.trim="car.plate" :state="car.plateState" @keyup="uppercase" trim autocomplete="off"></b-form-input>
								<b-input-group-append>
									<b-button variant="macal" class="px-5" @click="searchByPlate"><font-awesome-icon :icon="['fal', 'search']" size="lg" /></b-button>
								</b-input-group-append>
						</b-input-group>
					</b-form-group>
				</b-col>
			</b-navbar>
			<div v-if="showQuote">
				<v-section-grey :top="false">
					<b-container>
					<b-row>
						<b-col cols="12" md="6">
							<b-table-simple borderless condensed small class="mt-4">
								<b-tr>
									<b-th class="text-center">Datos de Auto</b-th>
								</b-tr>
								<b-tr>
									<b-td class="text-right">
										<multiselect class="multiselect-sm" v-model.trim="$v.car.brand.$model" :options="brands" :close-on-select="true" :show-labels="false" :loading="loading.brand" placeholder="Marca" track-by="value" label="text" @input="updateBrandText">
											<template slot="noOptions">No hay marcas disponibles.</template>
										</multiselect>
										<div class="invalid-feedback d-block" v-if="submited && !$v.car.brand.required">Debes ingresar Marca.</div>
									</b-td>
								</b-tr>
								<b-tr>
									<b-td class="text-right">
										<multiselect class="multiselect-sm"  v-model.trim="$v.car.year.$model" :loading="loading.year" :options="years" :close-on-select="true" :show-labels="false" placeholder="Año" track-by="value" label="text" @input="updateYearText">
											<template slot="noOptions">Debes seleccionar marca primero.</template>
										</multiselect>
										<div class="invalid-feedback d-block" v-if="submited && !$v.car.year.required">Debes ingresar Año.</div>
									</b-td>
								</b-tr>
								<b-tr>
									<b-td class="text-right ">
										<multiselect class="multiselect-sm"  v-model.trim="$v.car.model.$model" :loading="loading.model" :options="models" :close-on-select="true" :show-labels="false" placeholder="Modelo" track-by="value" label="text" @input="updateModelText">
											<template slot="noOptions">Debes seleccionar año primero.</template>
										</multiselect>
										<div class="invalid-feedback d-block" v-if="submited && !$v.car.model.required">Debes ingresar Modelo.</div>
									</b-td>
								</b-tr>
								<b-tr>
									<b-td class="text-right">
										<multiselect class="multiselect-sm"  v-model.trim="$v.car.version.$model" :loading="loading.version" :options="versions" :close-on-select="true" :show-labels="false" placeholder="Versión" track-by="value" label="text" @input="updateVersionText">
											<template slot="noOptions">Debes seleccionar modelo primero.</template>
										</multiselect>
										<div class="invalid-feedback d-block" v-if="submited && !$v.car.version.required">Debes ingresar Version.</div>
									</b-td>
								</b-tr>
								<b-tr>
									<b-td class="text-right">
										<multiselect class="multiselect-sm" v-model="car.km" :options="kms" :close-on-select="true" :show-labels="false" placeholder="Kilometraje" track-by="value" label="text" @input="updateKmText"></multiselect>
										<div class="invalid-feedback d-block" v-if="submited && !$v.car.km.required">Debes ingresar Kilometraje.</div>
									</b-td>
								</b-tr>
							</b-table-simple>
						</b-col>
						<b-col cols="12" md="6">
							<b-table-simple borderless condensed small class="mt-4">
								<b-tr>
									<b-th class="text-center">Tus Datos</b-th>
								</b-tr>
								<b-tr>
									<b-td class="text-right">
										<b-form-input size="sm" placeholder="E-Mail" v-model.trim="$v.reservation.email.$model" :state="$v.reservation.email.$dirty ? !$v.reservation.email.$error : null"></b-form-input>
										<b-form-invalid-feedback id="input-1-live-feedback">
											Email inválido.
										</b-form-invalid-feedback>
									</b-td>
								</b-tr>
								<b-tr>
									<b-td class="text-right">
										<b-form-input size="sm" placeholder="Teléfono" @keyup="addPlusToPhone" v-model.trim="$v.reservation.phone.$model" :state="$v.reservation.phone.$dirty ? !$v.reservation.phone.$error : null"></b-form-input>
										<b-form-invalid-feedback id="input-1-live-feedback">
											Número de teléfono incorrecto.
										</b-form-invalid-feedback>
									</b-td>
								</b-tr>
								<b-tr>
									<b-td colspan="2" class="pt-5 text-center">
										<b-form-group>
											<b-form-checkbox v-model.trim="$v.car.terms.$model" value="accepted" unchecked-value="not_accepted" :state="$v.car.terms.$dirty ? !$v.car.terms.$error : null" @change="car.termsState=null">
												Acepto los <a href="https://www.macal.cl/MiSitio/Asset/Docs/T%c3%a9rminos%20y%20condiciones%20Particulares%20Macal.pdf" target="_blank">Términos y condiciones</a> *
												<b-form-invalid-feedback :state="car.termsState">Debes aceptar los términos y condiciones</b-form-invalid-feedback>
											</b-form-checkbox>
										</b-form-group>
										<b-form-invalid-feedback id="input-1-live-feedback">
											Debes Aceptar los términos y condiciones.
										</b-form-invalid-feedback>
									</b-td>
								</b-tr>
								<b-tr>
									<b-td class="text-center">
										<vue-recaptcha ref="recaptcha" @verify="onVerify" :sitekey="captcha.sitekey"></vue-recaptcha>
									</b-td>
								</b-tr>
							</b-table-simple>
						</b-col>
						<b-col cols="12">
							<b-col v-if="send_loading" cols="12" class="text-center mt-5">
								<grid-loader :color="color"></grid-loader>
							</b-col>
							<b-col md="12" class="captcha-element text-center mt-3" >

							</b-col>
						</b-col>
						<b-col cols="12">
							<b-row>
								<b-col cols-md="12" v-if="this.errors" class="mt-3">
									<b-alert class="" variant="danger" show>{{ errors }}</b-alert>
								</b-col>
							</b-row>
							<b-col cols="12" class="text-center">
								<b-button size="lg" class=" mt-2 px-5" variant="outline-macal" @click="send">Revisa tu oferta</b-button>
							</b-col>
						</b-col>
					</b-row>
					</b-container>
				</v-section-grey>
			</div>
		</div>
</template>

<script>
	import Multiselect from 'vue-multiselect';
	import {es} from 'vuejs-datepicker/dist/locale';
	import SectionGrey from "../../../components/section-grey";
	import { required, minLength, maxLength, email } from "vuelidate/lib/validators";
	import VueRecaptcha from 'vue-recaptcha';

export default {
	name: 'v-sell-modal',
	components: {
		'v-section-grey': SectionGrey,
		Multiselect,
		VueRecaptcha
	},
	props: {
		price: String,
		openModal: {default: false},
		open: {default: false}
	},
	data (){
		return{
			showQuote: this.open,
			sendableQuote: false,
			send_loading: false,
			es: es,
			setSchedule: false,
			captcha: {
				sitekey: process.env.VUE_APP_CAPTCHA_KEY,
				valid: false,
				error: false,
			},
            color: "#E4610C",
			car:{
				plate: '',
				brand: null,
				year: null,
				model: null,
				version: null,
				offer: null,
				terms: null,
				termsState: null,
				plateInvalidFeedback: null,
				plateState: null,
				km: null,
			},
			data: {
				brandText: '-',
				yearText: '-',
				modelText: '-',
				versionText: '-',
				kmText: '-'
			},
			plateData: {
				brand: null,
				year: null,
				model: null,
				version: null
			},
			loading: {
				brand: false,
				year: false,
				model: false,
				version: false,
			},
			errors: '',
			hour: "",
			date: "",
			brands: [],
			years: [],
			models: [],
			versions: [],
			kms: [
				{ value: 5000, text: "5.000" },
				{ value: 10000, text: "10.000" },
				{ value: 20000, text: "20.000" },
				{ value: 30000, text: "30.000" },
				{ value: 40000, text: "40.000" },
				{ value: 50000, text: "50.000" },
				{ value: 60000, text: "60.000" },
				{ value: 70000, text: "70.000" },
				{ value: 80000, text: "80.000" },
				{ value: 90000, text: "90.000" },
				{ value: 100000, text: "100.000" },
				{ value: 150000, text: "150.000" },
				{ value: 200000, text: "200.000" },
			],
			dateState: {
				disabled: {
					to: new Date,
					from: new Date,
				},
				highlighted: {}
			},
			branch_id: null,
			dateTitle: null,
			hourTitle: null,
			branches: null,
			hours: [],
			reservation: {
				date: null,
				hour: null,
				quote_id: null,
				inspector_id: null,
				branch_id: null,
				name: null,
				lastname: null,
				email: null,
				phone: null,
				"g-recaptcha-response": ""
			},
			phone_reservation:{
				name: "",
				lastname: ""
			},
			submited: false,
		}
	},
	validations: {
		car:{
			brand: { required },
			year: { required },
			model: { required },
			version: { required },
			km: { required },
			terms: { required },
		},
		reservation: {
			phone: {required, minLength: minLength(12), maxLength: maxLength(12)},
			email: {required, email},
		},
		phone_reservation: {
			name: {required, minLength: minLength(3)},
			lastname: {required, minLength: minLength(3)},
		}
	},
	computed: {
		"car.plate": {
			get () { return this.car.plate },
			set (text) { this.car.plate = text.toUpperCase()}
		}
	},
	mounted() {
		this.$moment.locale('es');
		this.amount= this.price;
		this.setBrand();
		if(this.openModal){
			this.$bvModal.show('modal-sell');
		}
	},
	methods: {
		addPlusToPhone(){
			if(this.reservation.phone !== null){
				this.reservation.phone = '+'+this.reservation.phone.replace(/[|&;$%@"<>()+a-zA-Z,]/g,"");
			}
		},
		validateConfirmData(){
			this.$v.phone_reservation.$touch()
			this.$v.reservation.$touch()
			if(!this.$v.phone_reservation.$invalid && !this.$v.reservation.$invalid) this.showConfirmData = true
		},
		onVerify: function (response) {
			if(response.length > 0){
				this.captcha.valid = true
				this.captcha.error = false
				this.reservation["g-recaptcha-response"] = response
			}
		},
		uppercase(){
			this.car.plate = this.car.plate.toUpperCase()
		},
		searchByPlate(){
			const cur = this;
			cur.showQuote = true;
			if(this.car.plate.length > 0){
				cur.loading.year = true;
				cur.loading.model = true;
				cur.loading.version = true;
				this.axios.get("cars/search_by_plate", {params: {plate: this.car.plate}}).then(result => {
					cur.car.plateInvalidFeedback = null
					cur.car.plateState = null
					cur.plateData.brand = { value: result.data.brand_id, text: result.data.brand}
					cur.plateData.year = { value: result.data.year_id, text: result.data.year}
					cur.plateData.model = { value: result.data.model_id, text: result.data.model}
					cur.plateData.version = { value: result.data.version_id, text: result.data.version}
					cur.car.brand = cur.plateData.brand;
					cur.data.brandText = cur.plateData.brand.text;
					cur.setYear();
				}).catch(() => {
					cur.car.plateInvalidFeedback = "Patente no entontrada"
					//cur.car.plateState= false
					cur.$store.commit('hideLoading');
					cur.loading.year = false;
					cur.loading.model = false;
					cur.loading.version = false;
					cur.car.brand = null;
					cur.cleanYear();
					cur.cleanModel();
					cur.cleanVersion();
				})
			}

		},
		updateBrandText(event) {
			this.$v.car.$touch()
			this.data.brandText = event.text;
			this.loading.year = true;
			this.setYear();
			this.cleanModel();
			this.cleanVersion();
		},
		updateYearText(event) {
			this.data.yearText = event.text;
			this.loading.model = true;
			this.setModel();
			this.cleanVersion();
		},
		updateModelText(event) {
			this.data.modelText = event.text;
			this.loading.version = true;
			this.setVersion();
		},
		updateVersionText(event) {
			this.data.versionText = event.text;
		},
		updateKmText(event) {
			this.data.kmText = event.text;
		},
		changeStep(value) {
			this.step = value;
		},
		changeBrand(elem) {
			this.car.brand = elem;
			this.updateBrandText(elem);
		},
		setBrand(){
			const cur = this;
			cur.loading.brand = true;
			this.axios.get("cars/get_sell_brands")
			.then(result => {
				cur.loading.brand = false;
				cur.brands = result.data;
			})
			.catch(() => {
				cur.loading.brand = false;
				cur.$store.commit('hideLoading');
			})
		},
		setYear(){
			this.cleanYear();
			const cur = this;
			cur.loading.year = true;
			this.axios.get("cars/get_sell_years", {params: {brand_id: this.car.brand.value}}).then(result => {
				cur.loading.year = false;
				cur.years = result.data;
				if(cur.plateData.year){
					cur.car.year = cur.plateData.year;
					cur.data.yearText = cur.plateData.year.text;
					cur.setModel();
				}
			}).catch(() => {
				cur.loading.year = false;
				cur.$store.commit('hideLoading');
			})
		},
		setModel(){
			this.cleanModel();
			const cur = this;
			cur.loading.model = true;
			this.axios.get("cars/get_sell_models", {params: {brand_id: this.car.brand.value, year_id: this.car.year.value}})
			.then(result => {
				cur.loading.model = false;
				cur.models = result.data;
				if(cur.plateData.model){
					cur.car.model = cur.plateData.model;
					cur.data.modelText = cur.plateData.model.text;
					cur.setVersion();
				}
			})
			.catch(() => {
				cur.loading.model = false;
				cur.$store.commit('hideLoading');
			})
		},
		setVersion(){
			this.cleanVersion();
			const cur = this;
			cur.loading.version = true;
			this.axios.get("cars/get_sell_versions", {params: {brand_id: this.car.brand.value, year_id: this.car.year.value, model_id: this.car.model.value}})
			.then(result => {
				cur.loading.version = false;
				cur.versions = result.data;
				if(cur.plateData.year){
					cur.car.version = cur.plateData.version;
					cur.data.versionText = cur.plateData.version.text;
				}
				cur.resetPlateData();
			})
			.catch(() => {
				cur.loading.version = false;
				cur.$store.commit('hideLoading');
			})
		},
		cleanYear(){
			this.years= []
			this.car.year = null;
			this.data.yearText = "-";
		},
		cleanModel(){
			this.models = []
			this.car.model = null;
			this.data.modelText = "-";
		},
		cleanVersion(){
			this.versions = []
			this.car.version = null;
			this.data.versionText = "-";
		},
		resetPlateData(){
			this.plateData.brand = null;
			this.plateData.year = null;
			this.plateData.model = null;
		},
		send(){
			this.$v.car.$touch()
			this.$v.reservation.$touch()
			this.submited = true
			if(!this.$v.car.$invalid && !this.$v.reservation.$invalid){
				if(this.captcha.valid){
					const cur = this;
					cur.send_loading = true
					this.axios.post("sells/quote", {car: this.car, user: { email: this.reservation.email, phone: this.reservation.phone, "g-recaptcha-response": this.reservation["g-recaptcha-response"] }}).then(result => {
						//cur.car.offer = (result.data.Cotizacion.precio).toLocaleString('es');
						//cur.reservation.quote_id = result.data.Cotizacion.idCotizacion;
						//cur.branches = result.data.Sucursales;
						//cur.$v.reservation.$reset();
						cur.submited = false;
						cur.send_loading = false;
						cur.errors = "";
						window.location.href = result.data.LinkRedireccion;
						//cur.$router.push({ name: 'vehicles-sell-quote-response', params: {branches: cur.branches, data: cur.data, car: cur.car, reservation: cur.reservation}});
					})
					.catch(error => {
						cur.send_loading = false
						this.errors = error.data.data
					})
				}else{
					this.errors = "Debe validar captcha"
				}
			}
		}
	},
	watch: {
		"open": {
			handler: function() {
				this.showQuote = this.open;
			}
		}
	}

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
	#modal-sell___BV_modal_outer_{
		z-index: 1060 !important;
	}
	#modal-sell .multiselect-sm {
		height: 30px;
		font-size: 0.875rem !important;
		min-height: calc(1.5em + 0.5rem + 2px) !important;
		max-height: calc(1.5em + 0.5rem + 2px) !important;
		color: #35495e;
	}
	#modal-sell .multiselect-sm .multiselect__tags {
		height: 30px;
		font-size: 0.875rem !important;
		min-height: calc(1.5em + 0.5rem + 2px) !important;
		max-height: calc(1.5em + 0.5rem + 2px) !important;
		color: #35495e;
		padding: 0.25rem 0.5rem !important;
	}
	#modal-sell .multiselect-sm .multiselect__select {
		height: 30px;
		font-size: 0.875rem !important;
		min-height: calc(1.5em + 0.5rem + 2px) !important;
		max-height: calc(1.5em + 0.5rem + 2px) !important;
		padding: 0.25rem 0.5rem !important;
	}
	.w-100 .vdp-datepicker__calendar{
		width: 100%;
	}
	.captcha-element>div>div{
		margin-left: auto;
		margin-right: auto;
	}
	.multiselect__content-wrapper, .multiselect--active{
		z-index: 1030 !important;
	}
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
